import { SelectField } from '@yoti/ui-kit-components-react/select-field';
import React, { ChangeEventHandler } from 'react';
import { ConfigSection } from '@components/config/ConfigSection';

export interface ConfigThresholdProps {
    value?: number;
    onChange: (value?: number) => void;
}

const thresholdOptions = Object.values(Array.from({ length: 53 }, (_, i) => i + 12 + 1)).map(
    (threshold) => ({
        value: threshold,
        label: `${threshold}`,
    }),
);

const ThresholdFieldSection: React.FC<ConfigThresholdProps> = ({ value, onChange }) => {
    const handleChange: ChangeEventHandler<HTMLSelectElement> = ({ target: { value } }) => {
        onChange(parseInt(value, 10));
    };
    return (
        <ConfigSection title="Threshold">
            <SelectField
                name="threshold"
                options={thresholdOptions}
                label="Threshold"
                selectedValue={value}
                onChange={handleChange}
            />
        </ConfigSection>
    );
};

export default ThresholdFieldSection;
